import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    {...props}
  >
    <g clipPath='url(#a)'>
      <path
        fill='#DDD'
        d='M23.816 14.942a5.648 5.648 0 0 1-5.7 5.169h-3.198L9.004 24v-3.89l6.02-3.889h3.198a1.758 1.758 0 0 0 1.758-1.598c.213-2.984.16-5.968 0-9.005a1.652 1.652 0 0 0-1.599-1.491 103.999 103.999 0 0 0-12.68 0 1.652 1.652 0 0 0-1.598 1.545 62.74 62.74 0 0 0 0 8.95 1.758 1.758 0 0 0 1.758 1.6h3.197v3.889H5.86A5.648 5.648 0 0 1 .16 14.942a72.007 72.007 0 0 1 0-9.59A5.594 5.594 0 0 1 5.328.237a93.612 93.612 0 0 1 13.32 0 5.594 5.594 0 0 1 5.115 5.115c.213 3.197.266 6.394.053 9.59Z'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M0 0h23.952v24H0z' />
      </clipPath>
    </defs>
  </svg>
)

export const ChatIcon2 = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='stroke'
    >
      <path
        d='M18.3307 14.1667C18.3307 14.6087 18.1551 15.0326 17.8426 15.3452C17.53 15.6577 17.1061 15.8333 16.6641 15.8333H5.6874C5.2454 15.8334 4.82155 16.0091 4.50906 16.3217L2.67406 18.1567C2.59132 18.2394 2.4859 18.2957 2.37114 18.3186C2.25637 18.3414 2.13742 18.3297 2.02932 18.2849C1.92121 18.2401 1.82881 18.1643 1.7638 18.067C1.69879 17.9697 1.66408 17.8553 1.66406 17.7383V4.16667C1.66406 3.72464 1.83966 3.30072 2.15222 2.98816C2.46478 2.67559 2.8887 2.5 3.33073 2.5H16.6641C17.1061 2.5 17.53 2.67559 17.8426 2.98816C18.1551 3.30072 18.3307 3.72464 18.3307 4.16667V14.1667Z'
        stroke='current'
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 9.16406H10.0083'
        stroke='current'
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.3359 9.16406H13.3443'
        stroke='current'
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.66406 9.16406H6.6724'
        stroke='current'
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export default SvgComponent
